import { type PriceData } from "../models/PriceData";
import { type PriceInfo } from "../api/pna/PriceInfo";

/** @deprecated */
export function selectPrice(quantity: number, priceInfo?: PriceInfo | null): PriceData | undefined {
  if (!priceInfo) {
    return undefined;
  }

  const priceScaling = priceInfo.priceScale;

  if (!priceScaling || priceScaling.length === 0) {
    return undefined;
  }

  const index = selectPriceScalingIndex(quantity, priceScaling);
  return priceScaling[index]?.price;
}

export function selectSurcharge(quantity: number, priceInfo?: PriceInfo | null): number {
  if (!priceInfo) {
    return 0;
  }

  const priceScaling = priceInfo.surchargeScale;

  if (!priceScaling || priceScaling.length === 0) {
    return 0;
  }

  const index = selectPriceScalingIndex(quantity, priceScaling);
  return priceScaling[index]?.surcharge ?? 0;
}
export function selectRebate(quantity: number, priceInfo?: PriceInfo | null): string {
  if (!priceInfo) {
    return "";
  }

  const rebateScaling = priceInfo.rebateScale;

  if (!rebateScaling || rebateScaling.length === 0) {
    return "";
  }

  const index = selectPriceScalingIndex(quantity, rebateScaling);
  return rebateScaling[index]?.rebate ?? "";
}

export function selectPriceScalingIndex(quantity: number, priceScaling: { minQty: number }[]) {
  let selectedIndex = -1;

  for (const priceData of priceScaling) {
    if (priceData.minQty > quantity) {
      break;
    }
    selectedIndex++;
  }

  if (selectedIndex === -1) {
    return 0;
  }

  return selectedIndex;
}

export function selectPriceScalingElement<T extends { minQty: number }>(quantity: number, priceScaling: T[]): T;
export function selectPriceScalingElement<T extends { minQty: number }>(
  quantity: number,
  priceScaling: undefined | null,
): null;
export function selectPriceScalingElement<T extends { minQty: number }>(
  quantity: number,
  priceScaling: T[] | undefined | null,
): T | null;
export function selectPriceScalingElement<T extends { minQty: number }>(
  quantity: number,
  priceScaling: T[] | undefined | null,
): T | null {
  if (!priceScaling || priceScaling.length === 0) {
    return null;
  }
  const index = selectPriceScalingIndex(quantity, priceScaling);
  return priceScaling[index];
}
